import { u as useFederationLocalization } from "./fragmentLocalization.js";
function useFederationLocalizationRoot({
  i18next,
  networkService
}) {
  const federationLocalizations = /* @__PURE__ */ new Map();
  i18next == null ? void 0 : i18next.on("languageChanged", onLanguageChanged);
  return {
    getFederationLocalization
  };
  function getFederationLocalization(fragmentName) {
    if (!federationLocalizations.has(fragmentName)) {
      const fragmentNetwork = networkService.getFragmentNetwork(fragmentName);
      const localization = useFederationLocalization({ fragmentName, fragmentNetwork, i18next });
      federationLocalizations.set(fragmentName, localization);
    }
    return federationLocalizations.get(fragmentName);
  }
  function onLanguageChanged() {
    for (const federationLocalization of federationLocalizations.values()) {
      federationLocalization.setLocalization();
    }
  }
}
export {
  useFederationLocalizationRoot as u
};
//# sourceMappingURL=localization.js.map
